module.exports = __webpack_public_path__ + "Roboto-Bold.dc81817def276b4f2139.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Bold.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-Bold.woff
// module chunks = 29